import { lazy } from "react";

const CreateEvent = lazy(() => import("./CreateEvent"));

export default CreateEvent;
